import { render, staticRenderFns } from "./WorkReadOnly.vue?vue&type=template&id=22b65af0"
import script from "./WorkReadOnly.vue?vue&type=script&lang=js"
export * from "./WorkReadOnly.vue?vue&type=script&lang=js"
import style0 from "./WorkReadOnly.vue?vue&type=style&index=0&id=22b65af0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports